export enum PreliminaryCheckResult {
  Fail = 'Fail',
  PrescreenDoesNotMatch = 'Prescreen does not match',
  OrganicTrafficIneligibleZipCode = 'Organic Traffic Ineligible Zip Code',
  NoPrescreenedOffer = 'No Prescreened Offer',
  SuccessOrganicTraffic = 'Success Organic Traffic',
  SuccessPrescreenedOffer = 'Success Prescreened Offer',
  SuccessRefiMismatch = 'Success Refi Mismatch',
  SuccessRefiMatch = 'Success Refi Match',
}
